import CorporatePodcastListRepository from "./../api/index"
import "../types"

class CorporatePodcastListUseCase {
    constructor() {
        /** @type {CorporatePodcastListRepository}*/
        this.api = new CorporatePodcastListRepository()
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        const {data, err} = await this.api.getAll(queries)
        if (err && err === "record not found") {
          return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new CorporatePodcastListUseCase()
